import { ToastData, ToastInstance } from './ToastInstance'

export interface UseToast {
  toasts: ToastInstance[]
  create: (data: ToastData) => ToastInstance
  remove: (id: string) => void
  update: (id: string, _update: Partial<ToastInstance>) => void
}
